import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

const ListingCount = ({ displayedHomes, totalHomes }) => {
  return (
    <div className='ListingCount'>
      <p className='ListingCount-text'>
        {`${displayedHomes} of ${totalHomes} ${totalHomes === 1 ? 'home' : 'homes'}`}
      </p>
    </div>
  )
}

ListingCount.propTypes = {
  displayedHomes: PropTypes.number,
  totalHomes: PropTypes.number
}
export default observer(ListingCount)
